import ProblemReportModal from './ProblemReportModal';

export default ProblemReportModal;
